webpackJsonp([0],{

/***/ "+1wc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Slide pb-4",style:({ 'background-image': 'url(./static/images/gallery/' + _vm.galleryContent.sections[_vm.sectionIndex].directory + '/' + _vm.galleryContent.sections[_vm.sectionIndex].subsections[_vm.slideIndex].backgroundImgFileName + ')' }),attrs:{"id":_vm.galleryContent.sections[_vm.sectionIndex].subsections[_vm.slideIndex].id}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-3"},[_c('div',{staticClass:"ButtonIcon ButtonIcon--small ButtonIcon--light mx-auto",attrs:{"title":"Return to Top"},on:{"click":function($event){_vm.jumpToId('app')}}},[_c('icon',{attrs:{"name":"arrow-up","scale":".85"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col my-3 text-center"},[_c('h4',{staticClass:"Slide-goHome",on:{"click":function($event){_vm.jumpToId('app')}}},[_vm._v("Return to Top")])])]),_vm._v(" "),_c('app-image-slider',{attrs:{"id":'gallery-' + _vm.slideIndex,"imageLs":_vm.galleryContent.sections[_vm.sectionIndex].subsections[_vm.slideIndex].images,"parentDir":'gallery' + '/' + _vm.galleryContent.sections[_vm.sectionIndex].directory}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+8s/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gallery_section_vue__ = __webpack_require__("cE5y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78f00950_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gallery_section_vue__ = __webpack_require__("gRrK");
function injectStyle (ssrContext) {
  __webpack_require__("CZxa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78f00950"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gallery_section_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78f00950_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gallery_section_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+iok":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return About; });
/* unused harmony export Image */
/* unused harmony export Subsection */
/* unused harmony export Section */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Gallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Article = function Article() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Article);

  this.heading = '';
  this.body = '';
};

var About = function About(articleQty) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, About);

  var articleLs = [];

  for (var i = 0; i < articleQty; i++) {
    var article = new Article();
    articleLs.push(article);
  }

  this.introImage = {
    fileName: '',
    title: ''
  };
  this.title = '';
  this.intro = '';
  this.articles = articleLs;
};

var Image = function Image() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Image);

  this.fileName = '';
  this.title = '';
  this.portait = '';
  this.caption = '';
};

var Subsection = function Subsection(imageQty) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Subsection);

  var imageLs = [];

  for (var i = 0; i < imageQty; i++) {
    var image = new Image();
    imageLs.push(image);
  }

  this.name = '';
  this.id = '';
  this.backgroundImgFileName = '';
  this.images = imageLs;
  this.previewImage = '';
};

var Section = function Section(subsectionQty, imageQty, previewImgQty) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Section);

  var subsectionsLs = [];
  var previewImgLs = [];

  for (var i = 0; i < subsectionQty; i++) {
    var subsection = new Subsection(imageQty);
    subsectionsLs.push(subsection);
  }

  for (var j = 0; j < previewImgQty; j++) {
    var previewImg = new Image();
    previewImgLs.push(previewImg);
  }

  this.name = '';
  this.directory = '';
  this.subsections = subsectionsLs;
  this.previewImages = previewImgLs;
};

var Gallery = function Gallery(sectionQty, subsectionQty, imageQty, previewImgQty) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Gallery);

  var sectionLs = [];

  for (var i = 0; i < sectionQty; i++) {
    var section = new Section(subsectionQty, imageQty, previewImgQty);
    sectionLs.push(section);
  }

  this.title = '';
  this.description = '';
  this.sections = sectionLs;
};

/***/ }),

/***/ "/4ba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageSlider_vue__ = __webpack_require__("H2ep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4649bf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imageSlider_vue__ = __webpack_require__("km2b");
function injectStyle (ssrContext) {
  __webpack_require__("D/ab")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4649bf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4649bf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imageSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0K9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_background__ = __webpack_require__("QtNj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about',

  components: {
    appBackground: __WEBPACK_IMPORTED_MODULE_0__partials_background__["a" /* default */]
  },

  computed: {
    aboutContent: function aboutContent() {
      return this.$store.getters.aboutContent;
    },
    sharedContent: function sharedContent() {
      return this.$store.getters.sharedContent;
    }
  },

  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getLocalData', 'about');
  }
});

/***/ }),

/***/ "0rEw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RouteContainer"},[_c('app-gallery-section',{attrs:{"sectionIndex":1}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "28lb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2ICm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_background__ = __webpack_require__("QtNj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_helper__ = __webpack_require__("nAmR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_arrow_right__ = __webpack_require__("vDhf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appBackground: __WEBPACK_IMPORTED_MODULE_0__partials_background__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_helper__["a" /* default */]],

  data: function data() {
    return {
      selectedSection: null
    };
  },


  computed: {
    sharedContent: function sharedContent() {
      return this.$store.getters.sharedContent;
    },
    galleryContent: function galleryContent() {
      return this.$store.getters.galleryContent;
    }
  },

  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getLocalData', 'gallery');
  }
});

/***/ }),

/***/ "2NMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wolves_and_people_vue__ = __webpack_require__("Y7sP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f7005fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wolves_and_people_vue__ = __webpack_require__("UDEO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wolves_and_people_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f7005fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wolves_and_people_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5lvk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_landscape_map_vue__ = __webpack_require__("VO4F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af14321_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_landscape_map_vue__ = __webpack_require__("g2ZE");
function injectStyle (ssrContext) {
  __webpack_require__("qxiW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1af14321"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_landscape_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af14321_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_landscape_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "65Hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("JER+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf3519c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("DCUF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf3519c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6kjB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6vV4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container h-100"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-3"},[_c('div',{staticClass:"ButtonIcon ButtonIcon--small ButtonIcon--light mx-auto",attrs:{"title":"Return to Exploring the Wolf"},on:{"click":function($event){_vm.updateState(null, 'appWolfmap', 'slideDown')}}},[_c('icon',{attrs:{"name":"home","scale":".85"}})],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.wolfState.animation,"mode":"out-in"},on:{"after-enter":function($event){_vm.setProp('helpers', 'overflow', 'visible')},"before-leave":function($event){_vm.setProp('helpers', 'overflow', 'hidden')},"after-leave":function($event){_vm.setProp('helpers', 'overflow', 'hidden')}}},[_c('app-image-slider',{key:_vm.generateKey(),staticClass:"my-3",attrs:{"id":_vm.wolfState.currentDetail.name,"imageLs":_vm.wolfState.currentDetail.images,"parentDir":'explore'}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7WPe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helper__ = __webpack_require__("nAmR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_home__ = __webpack_require__("8AWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_imageSlider__ = __webpack_require__("/4ba");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appImageSlider: __WEBPACK_IMPORTED_MODULE_3__partials_imageSlider__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helper__["a" /* default */]],

  computed: {
    nextDetail: function nextDetail() {
      var details = this.wolfContent.mapDetail;
      var i = this.getDetailIndex(this.wolfState.currentDetail.name);
      if (i === details.length - 1) {
        return this.wolfContent.mapDetail[0];
      } else {
        i += 1;
        return this.wolfContent.mapDetail[i];
      }
    },
    prevDetail: function prevDetail() {
      var details = this.wolfContent.mapDetail;
      var i = this.getDetailIndex(this.wolfState.currentDetail.name);
      if (i === 0) {
        i = details.length - 1;
        return this.wolfContent.mapDetail[i];
      } else {
        i -= 1;
        return this.wolfContent.mapDetail[i];
      }
    },
    wolfContent: function wolfContent() {
      return this.$store.getters.wolfContent;
    },
    wolfState: function wolfState() {
      return this.$store.getters.wolfState;
    }
  },

  created: function created() {
    window.addEventListener('wheel', this.scrollHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('wheel', this.scrollHandler);
  },


  methods: {
    getDetailIndex: function getDetailIndex(detailName) {
      return _.findIndex(this.wolfContent.mapDetail, { name: detailName });
    },
    scrollHandler: function scrollHandler(e) {
      this.scrollHome(e);
      // this.scrollNext(e)
    },
    scrollHome: function scrollHome(e) {
      if (e.deltaY < 0 && window.scrollY === 0) {
        this.updateState(null, 'appWolfmap', 'slideDown');
      }
    },
    scrollNext: function scrollNext(e) {
      // document.body.scrollTop for IE
      var scrollY = document.body.scrollTop || window.pageYOffset;
      if (scrollY + window.innerHeight + 50 >= document.body.scrollHeight && e.deltaY > 0) {
        this.updateState(this.nextDetail, 'appWolfDetail', 'slideUp');
      }
    },
    setProp: function setProp(parent, key, value) {
      var payload = {
        parent: parent,
        key: key,
        value: value
      };
      this.$store.dispatch('setProp', payload);
    },
    updateState: function updateState(selection, view, animation) {
      var payload = {
        parent: 'wolfmap',
        updates: {
          currentDetail: selection,
          currentView: view,
          animation: animation || 'fade'
        }
      };
      this.$store.dispatch('updateProps', payload);
    }
  }
});

/***/ }),

/***/ "7pO/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10 col-md-8 col-lg-8 mx-auto my-3 Blurb",class:{ 'is-blurred': _vm.menuIsOpen }},[_c('h2',[_vm._v("Explore the Wolf")]),_vm._v(" "),_c('p',{staticClass:"Blurb-body"},[_vm._v(_vm._s(_vm.wolfContent.intro))]),_vm._v(" "),_c('p',{staticClass:"Blurb-blockquote mt-3 text-center"},[_vm._v("Click below to explore the wolf, one of earth’s most intelligent and capable top predators.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-3 mb-5 ImageMap-container",class:{ 'is-blurred': _vm.menuIsOpen },on:{"mouseover":function($event){_vm.pingHidden = false},"mouseout":function($event){_vm.pingHidden = true}}},[_c('svg',{staticClass:"ImageMap ImageMap--ie",staticStyle:{"enable-background":"new 0 0 2377 1394"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 2377 1394","xml:space":"preserve"}},[_c('g',{attrs:{"id":"base"}},[_c('g',{attrs:{"id":"Layer_1_1_"}},[_c('image',{staticStyle:{"overflow":"visible","enable-background":"new"},attrs:{"width":"1100","height":"645","xlink:href":__webpack_require__("VmZH"),"transform":"matrix(2.161 0 0 2.161 0.121 3.083901e-02)"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Hotspot Hotspot--wolfmaps"}},[_c('rect',{staticClass:"st3",attrs:{"id":"ears-Hotspot Hotspot--wolfmap","x":"1916.5","y":"221.3","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-ears')},"mouseover":function($event){_vm.detailHandler('wolf-ears', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"tracks-Hotspot Hotspot--wolfmap","x":"282.1","y":"514.4","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-tracks')},"mouseover":function($event){_vm.detailHandler('wolf-tracks', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"title-Hotspot Hotspot--wolfmap","x":"444.5","y":"146.4","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-size')},"mouseover":function($event){_vm.detailHandler('wolf-size', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"speed-Hotspot Hotspot--wolfmap","x":"1171.5","y":"206.3","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-speed')},"mouseover":function($event){_vm.detailHandler('wolf-speed', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"skull-Hotspot Hotspot--wolfmap","x":"1552.5","y":"45.3","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-skull')},"mouseover":function($event){_vm.detailHandler('wolf-skull', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"pup-Hotspot Hotspot--wolfmap","x":"1231.3","y":"987.4","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-pup')},"mouseover":function($event){_vm.detailHandler('wolf-pup', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"pack-Hotspot Hotspot--wolfmap","x":"704.5","y":"36.3","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-pack')},"mouseover":function($event){_vm.detailHandler('wolf-pack', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"nose-Hotspot Hotspot--wolfmap","x":"1814.5","y":"458.8","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-nose')},"mouseover":function($event){_vm.detailHandler('wolf-nose', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"learning-Hotspot Hotspot--wolfmap","x":"555.1","y":"1021.4","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-learning')},"mouseover":function($event){_vm.detailHandler('wolf-learning', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"hunt-Hotspot Hotspot--wolfmap","x":"2203.3","y":"1005.1","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-hunt')},"mouseover":function($event){_vm.detailHandler('wolf-hunt', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"fur-Hotspot Hotspot--wolfmap","x":"644.6","y":"294.7","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-fur')},"mouseover":function($event){_vm.detailHandler('wolf-fur', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"eyes-Hotspot Hotspot--wolfmap","x":"2189.5","y":"486.3","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-eyes')},"mouseover":function($event){_vm.detailHandler('wolf-eyes', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}}),_vm._v(" "),_c('rect',{staticClass:"st3",attrs:{"id":"chest-Hotspot Hotspot--wolfmap","x":"1135.3","y":"637.1","width":"119.7","height":"119.7"},on:{"click":function($event){_vm.updateState('wolf-chest')},"mouseover":function($event){_vm.detailHandler('wolf-chest', 'mouseover')},"mouseout":function($event){_vm.detailHandler(null, 'mouseout')}}})])]),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--ears Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-ears')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"25%","left":"75%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Ears")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore the ears of the wolf")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--chest Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-chest')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"52%","left":"51%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Chest")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore the chest of the wolf")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--eyes Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-eyes')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"43%","left":"80%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Eyes")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore the eyes of the wolf")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--fur Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-fur')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"29%","left":"29%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Fur")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore the coat of the wolf")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--hunt Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-hunt')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"79%","left":"78%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Hunting")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore wolves on the hunt")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--learning Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-learning')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"82%","left":"22%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Learning")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore how young wolves learn from adults")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--nose Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-nose')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"41%","left":"77%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Nose")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore the nose of the wolf")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--pack Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-pack')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"11%","left":"31%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Pack")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore the size of a pack")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--pup Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-pup')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"78%","left":"52%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Pups")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore the lives of wolf pups")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--skull Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-skull')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"11%","left":"65%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Skull")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore the cranial structure of the wolf")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--speed Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-speed')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"23%","left":"50%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Speed")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore the speed of the wolf")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--title Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-size')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"18%","left":"20%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Size")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore the size of the wolf")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--tracks Hotspot--wolfmap ping--continuous",class:{ 'is-hidden': _vm.pingHidden }}),_vm._v(" "),(_vm.detail.name === 'wolf-tracks')?_c('div',{staticClass:"Tooltip Tooltip--wolfMap",class:{ 'is-shown': !_vm.pingHidden },staticStyle:{"top":"45%","left":"12%"}},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v("Tracks")]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v("Explore wolf tracks")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row Contents"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.menuIsOpen)?_c('div',{staticClass:"col-md-4 mx-auto Contents-container"},[_c('ol',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.closeMenu),expression:"closeMenu"}],staticClass:"Contents-menu"},_vm._l((_vm.wolfContent.mapDetail),function(detail,i){return _c('li',{key:i,staticClass:"Contents-menu-item",on:{"click":function($event){_vm.updateState(detail.name)}}},[_vm._v("\n            "+_vm._s(detail.title)+"\n          ")])}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 mx-auto"},[_c('button',{staticClass:"Button Button--transparent mx-auto mb-5",on:{"click":function($event){_vm.menuIsOpen = !_vm.menuIsOpen}}},[_vm._v("\n        "+_vm._s((_vm.menuIsOpen) ? 'Hide Contents' : 'Show Contents')+"\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8y8H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9NPo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__("0K9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b630726_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__("M/2+");
function injectStyle (ssrContext) {
  __webpack_require__("EBxN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b630726"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b630726_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CFg9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landscape-with-wolves.067b688.jpg";

/***/ }),

/***/ "CN8O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RouteContainer",staticStyle:{"height":"100vh"},style:({ overflow: _vm.helperState.overflow })},[_c('app-audio',{attrs:{"src":'./static/audio/' + _vm.wolfContent.audio}}),_vm._v(" "),_c('app-background',{attrs:{"backgroundImg":'./static/images/explore/' + _vm.wolfContent.backgroundImg}}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.wolfState.animation,"mode":"out-in"},on:{"after-enter":function($event){_vm.setProp('helpers', 'overflow', 'visible')},"before-leave":function($event){_vm.setProp('helpers', 'overflow', 'hidden')},"after-leave":function($event){_vm.setProp('helpers', 'overflow', 'hidden')}}},[_c(_vm.wolfState.currentView,{tag:"component"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CZxa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D/ab":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_35dd18da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("XfxO");
function injectStyle (ssrContext) {
  __webpack_require__("z0na")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_35dd18da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DCUF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-background',{attrs:{"backgroundImg":'./static/images/' + _vm.sharedContent.backgroundImg}}),_vm._v(" "),_c('app-nav-attract')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DIQl":
/***/ (function(module, exports) {

module.exports = {"siteTitle":"The Hidden Life of Wolves","navigation":[{"title":"Wolves 101","slug":"wolves-101","defaultView":{"parent":"","view":""}},{"title":"Explore the Wolf","slug":"explore-the-wolf","defaultView":{"parent":"wolfmap","view":"appWolfmap"}},{"title":"Ecosystem","slug":"ecosystem","defaultView":{"parent":"","view":""}},{"title":"About","slug":"about","defaultView":{"parent":"","view":""}},{"title":"Take Action","slug":"take-action","defaultView":{"parent":"","view":""}}]}

/***/ }),

/***/ "DKgP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RouteContainer pb-5"},[_c('app-background',{attrs:{"backgroundImg":'./static/images/' + _vm.sharedContent.backgroundImgBlur}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 mx-auto mt-3"},[_c('div',{staticClass:"Blurb text-center text-lg-left"},[_vm._v(_vm._s(_vm.localContent[0].intro))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 mt-3"},[_c('img',{attrs:{"src":'./static/images/takeAction/' + _vm.localContent[1].cards[0].image.fileName,"alt":_vm.localContent[1].cards[0].image.title}}),_vm._v(" "),_c('div',{staticClass:"Blurb Blurb--dark mt-3"},[_c('h2',{staticClass:"Card-title"},[_vm._v(_vm._s(_vm.localContent[1].cards[0].title))]),_vm._v(" "),_c('h3',{staticClass:"Card-subheading mt-3"},[_vm._v(_vm._s(_vm.localContent[1].cards[0].subheadings[0]))]),_vm._v(" "),_c('p',{staticClass:"text-center text-lg-left"},[_vm._v("Visit us at "),_c('a',{staticClass:"LinkInline",attrs:{"href":_vm.localContent[1].cards[0].socialLinks[0],"target":"_blank","rel":"noopener"}},[_vm._v("livingwithwolves.org")]),_vm._v(" and follow us on "),_c('a',{staticClass:"LinkInline",attrs:{"href":_vm.localContent[1].cards[0].socialLinks[1],"target":"_blank","rel":"noopener"}},[_vm._v("Facebook")]),_vm._v(", "),_c('a',{staticClass:"LinkInline",attrs:{"href":_vm.localContent[1].cards[0].socialLinks[2],"target":"_blank","rel":"noopener"}},[_vm._v("Instagram")]),_vm._v(", "),_c('a',{staticClass:"LinkInline",attrs:{"href":_vm.localContent[1].cards[0].socialLinks[3],"target":"_blank","rel":"noopener"}},[_vm._v("Twitter")]),_vm._v(" for news, important information, and answers to your questions. We dispel myths and share clear facts about the importance of wolves in our world, and the threats that they face.")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.localContent[1].cards[0].buttons[0].link,"target":"_blank","rel":"noopener"}},[_c('button',{staticClass:"Button Button--dark mt-3 mx-auto"},[_vm._v(_vm._s(_vm.localContent[1].cards[0].buttons[0].text))])]),_vm._v(" "),_c('ul',{staticClass:"Blurb-list Social-list mt-3 mx-auto"},[_c('a',{attrs:{"href":_vm.localContent[1].cards[0].socialLinks[1],"target":"_blank","rel":"noopener"}},[_c('li',{staticClass:"Social-list-item"},[_c('svg',{attrs:{"version":"1.2","baseProfile":"tiny","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 47 47","xml:space":"preserve"}},[_c('g',{attrs:{"id":"icon-wrapper--fb"}},[_c('g',[_c('path',{attrs:{"d":"M5.7,46C3.1,46,1,43.9,1,41.3V5.7C1,3.1,3.1,1,5.7,1h35.7C43.9,1,46,3.1,46,5.7v35.7c0,2.6-2.1,4.7-4.7,4.7H5.7z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFFFFF","d":"M41.3,2c2,0,3.7,1.6,3.7,3.7v35.7c0,2-1.6,3.7-3.7,3.7H5.7c-2,0-3.7-1.6-3.7-3.7V5.7C2,3.6,3.6,2,5.7,2\n                        H41.3 M41.3,0H5.7C2.5,0,0,2.5,0,5.7v35.7C0,44.5,2.5,47,5.7,47h35.7c3.1,0,5.7-2.5,5.7-5.7V5.7C47,2.5,44.5,0,41.3,0L41.3,0z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"facebook"}},[_c('path',{staticClass:"icon",attrs:{"fill":"#FFFFFF","d":"M26,18.5v-3c0-1.3,0.3-2,2.4-2H31v-5h-4c-5,0-7,3.3-7,7v3h-4v5h4v15h6v-15h4.4l0.6-5H26z"}})])])])]),_vm._v(" "),_c('a',{attrs:{"href":_vm.localContent[1].cards[0].socialLinks[2],"target":"_blank","rel":"noopener"}},[_c('li',{staticClass:"Social-list-item"},[_c('svg',{attrs:{"version":"1.2","baseProfile":"tiny","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 47 47","xml:space":"preserve"}},[_c('g',{attrs:{"id":"icon-wrapper--instagram"}},[_c('g',[_c('path',{attrs:{"d":"M5.7,46C3.1,46,1,43.9,1,41.3V5.7C1,3.1,3.1,1,5.7,1h35.7C43.9,1,46,3.1,46,5.7v35.7c0,2.6-2.1,4.7-4.7,4.7H5.7z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFFFFF","d":"M41.3,2c2,0,3.7,1.6,3.7,3.7v35.7c0,2-1.6,3.7-3.7,3.7H5.7c-2,0-3.7-1.6-3.7-3.7V5.7C2,3.6,3.6,2,5.7,2\n                        H41.3 M41.3,0H5.7C2.5,0,0,2.5,0,5.7v35.7C0,44.5,2.5,47,5.7,47h35.7c3.1,0,5.7-2.5,5.7-5.7V5.7C47,2.5,44.5,0,41.3,0L41.3,0z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"instagram"}},[_c('g',{attrs:{"display":"inline"}},[_c('path',{staticClass:"icon",attrs:{"fill":"#FFFFFF","d":"M23.5,12.8c3.5,0,3.9,0,5.3,0.1c1.3,0.1,2,0.3,2.4,0.4c0.6,0.2,1.1,0.5,1.5,1c0.4,0.4,0.8,0.9,1,1.5\n                          c0.2,0.5,0.4,1.1,0.4,2.4c0.1,1.4,0.1,1.8,0.1,5.3s0,3.9-0.1,5.3c-0.1,1.3-0.3,2-0.4,2.4c-0.4,1.1-1.3,2-2.5,2.5\n                          c-0.5,0.2-1.1,0.4-2.4,0.4c-1.4,0.1-1.8,0.1-5.3,0.1s-3.9,0-5.3-0.1c-1.3-0.1-2-0.3-2.4-0.4c-0.6-0.2-1.1-0.5-1.5-1\n                          c-0.4-0.4-0.8-0.9-1-1.5c-0.2-0.5-0.4-1.1-0.4-2.4c-0.1-1.4-0.1-1.8-0.1-5.3s0-3.9,0.1-5.3c0.1-1.3,0.3-2,0.4-2.4\n                          c0.2-0.6,0.5-1.1,1-1.5c0.4-0.4,0.9-0.8,1.5-1c0.5-0.2,1.1-0.4,2.4-0.4C19.6,12.9,20,12.8,23.5,12.8 M23.5,10.5\n                          c-3.5,0-4,0-5.4,0.1c-1.4,0.1-2.3,0.3-3.2,0.6c-0.9,0.3-1.7,0.8-2.3,1.5c-0.7,0.6-1.2,1.4-1.5,2.3c-0.3,0.8-0.5,1.8-0.6,3.2\n                          c-0.1,1.4-0.1,1.8-0.1,5.4s0,4,0.1,5.4c0.1,1.4,0.3,2.3,0.6,3.2c0.3,0.9,0.8,1.7,1.5,2.3c0.6,0.7,1.4,1.2,2.3,1.5\n                          c0.8,0.3,1.8,0.5,3.2,0.6c1.4,0.1,1.8,0.1,5.4,0.1s4,0,5.4-0.1c1.4-0.1,2.3-0.3,3.2-0.6c1.7-0.7,3.1-2.1,3.8-3.8\n                          c0.3-0.8,0.5-1.8,0.6-3.2c0.1-1.4,0.1-1.8,0.1-5.4s0-4-0.1-5.4c-0.1-1.4-0.3-2.3-0.6-3.2c-0.3-0.9-0.8-1.7-1.5-2.3\n                          c-0.6-0.7-1.4-1.2-2.3-1.5c-0.8-0.3-1.8-0.5-3.2-0.6C27.5,10.5,27,10.5,23.5,10.5L23.5,10.5L23.5,10.5z"}}),_vm._v(" "),_c('path',{staticClass:"icon",attrs:{"fill":"#FFFFFF","d":"M23.5,16.8c-3.7,0-6.7,3-6.7,6.7s3,6.7,6.7,6.7s6.7-3,6.7-6.7l0,0C30.2,19.8,27.2,16.8,23.5,16.8z\n                          M23.5,27.8c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3C27.8,25.9,25.9,27.8,23.5,27.8z"}}),_vm._v(" "),_c('circle',{staticClass:"icon",attrs:{"fill":"#FFFFFF","cx":"30.4","cy":"16.6","r":"1.6"}})])])])])]),_vm._v(" "),_c('a',{attrs:{"href":_vm.localContent[1].cards[0].socialLinks[3],"target":"_blank","rel":"noopener"}},[_c('li',{staticClass:"Social-list-item"},[_c('svg',{attrs:{"version":"1.2","baseProfile":"tiny","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 47 47","xml:space":"preserve"}},[_c('g',{attrs:{"id":"icon-wrapper--twitter"}},[_c('g',[_c('path',{attrs:{"d":"M5.7,46C3.1,46,1,43.9,1,41.3V5.7C1,3.1,3.1,1,5.7,1h35.7C43.9,1,46,3.1,46,5.7v35.7c0,2.6-2.1,4.7-4.7,4.7H5.7z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FFFFFF","d":"M41.3,2c2,0,3.7,1.6,3.7,3.7v35.7c0,2-1.6,3.7-3.7,3.7H5.7c-2,0-3.7-1.6-3.7-3.7V5.7C2,3.6,3.6,2,5.7,2\n                        H41.3 M41.3,0H5.7C2.5,0,0,2.5,0,5.7v35.7C0,44.5,2.5,47,5.7,47h35.7c3.1,0,5.7-2.5,5.7-5.7V5.7C47,2.5,44.5,0,41.3,0L41.3,0z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"twitter"}},[_c('g',{attrs:{"id":"layer1","transform":"translate(-539.17946,-568.85777)","display":"inline"}},[_c('path',{staticClass:"icon",attrs:{"id":"path3611","fill":"#FFFFFF","d":"M557.9,602.9c9.8,0,15.2-8.1,15.2-15.2c0-0.2,0-0.5,0-0.7c1-0.8,1.9-1.7,2.7-2.8\n                        c-1,0.4-2,0.7-3.1,0.8c1.1-0.7,1.9-1.7,2.3-3c-1,0.6-2.2,1.1-3.4,1.3c-1-1-2.4-1.7-3.9-1.7c-2.9,0-5.3,2.4-5.3,5.3\n                        c0,0.4,0,0.8,0.1,1.2c-4.4-0.2-8.4-2.3-11-5.6c-0.5,0.8-0.7,1.7-0.7,2.7c0,1.9,0.9,3.5,2.4,4.4c-0.9,0-1.7-0.3-2.4-0.7\n                        c0,0,0,0,0,0.1c0,2.6,1.8,4.7,4.3,5.2c-0.4,0.1-0.9,0.2-1.4,0.2c-0.3,0-0.7,0-1-0.1c0.7,2.1,2.6,3.7,5,3.7\n                        c-1.8,1.4-4.1,2.3-6.6,2.3c-0.4,0-0.9,0-1.3-0.1C552,602,554.8,602.9,557.9,602.9"}})])])])])])]),_vm._v(" "),_c('h3',{staticClass:"Card-subheading mt-5"},[_vm._v(_vm._s(_vm.localContent[1].cards[0].subheadings[1]))]),_vm._v(" "),_c('p',{staticClass:"text-center text-lg-left"},[_vm._v("Read our books and watch our documentaries to learn more about wolves and the Sawtooth Pack.")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.localContent[1].cards[0].buttons[1].link,"target":"_blank","rel":"noopener"}},[_c('button',{staticClass:"Button Button--dark mt-3 mx-auto"},[_vm._v(_vm._s(_vm.localContent[1].cards[0].buttons[1].text))])]),_vm._v(" "),_c('h3',{staticClass:"Card-subheading mt-5"},[_vm._v(_vm._s(_vm.localContent[1].cards[0].subheadings[2]))]),_vm._v(" "),_c('p',{staticClass:"text-center text-lg-left"},[_vm._v("Download our wolf educator guide for use in formal classrooms, museums, or at home. The activity guide is geared toward grades K-12 and the activities relate back to common core standards. The guide was created by Living with Wolves and National Geographic.")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.localContent[1].cards[0].buttons[2].link,"target":"_blank","rel":"noopener"}},[_c('button',{staticClass:"Button Button--dark mt-3 mx-auto"},[_vm._v(_vm._s(_vm.localContent[1].cards[0].buttons[2].text))])]),_vm._v(" "),_c('h3',{staticClass:"Card-subheading mt-5"},[_vm._v(_vm._s(_vm.localContent[1].cards[0].subheadings[3]))]),_vm._v(" "),_c('p',{staticClass:"text-center text-lg-left"},[_vm._v("Purchase prints of the beautiful photos you see on this site from our partner, National Geographic Creative.")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.localContent[1].cards[0].buttons[3].link,"target":"_blank","rel":"noopener"}},[_c('button',{staticClass:"Button Button--dark mt-3 mx-auto"},[_vm._v(_vm._s(_vm.localContent[1].cards[0].buttons[3].text))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 mt-3"},[_c('img',{attrs:{"src":'./static/images/takeAction/' + _vm.localContent[1].cards[1].image.fileName,"alt":_vm.localContent[1].cards[1].image.title}}),_vm._v(" "),_c('div',{staticClass:"Blurb Blurb--dark mt-3"},[_c('h2',{staticClass:"Card-title"},[_vm._v(_vm._s(_vm.localContent[1].cards[1].title))]),_vm._v(" "),_c('h3',{staticClass:"Card-subheading mt-3"},[_vm._v(_vm._s(_vm.localContent[1].cards[1].subheadings[0]))]),_vm._v(" "),_c('p',{staticClass:"Blurb-body text-center text-lg-left"},[_vm._v(_vm._s(_vm.localContent[1].cards[1].description))]),_vm._v(" "),_c('ul',{staticClass:"Blurb-list"},[_c('li',{staticClass:"Blurb-list-item--block"},[_vm._v(_vm._s(_vm.localContent[1].cards[1].actions[0]))]),_vm._v(" "),_c('li',{staticClass:"Blurb-list-item--block"},[_vm._v(_vm._s(_vm.localContent[1].cards[1].actions[1]))])]),_vm._v(" "),_c('a',{attrs:{"href":_vm.localContent[1].cards[1].button.link,"target":"_blank","rel":"noopener"}},[_c('button',{staticClass:"Button Button--dark mt-3 mx-auto"},[_vm._v(_vm._s(_vm.localContent[1].cards[1].button.text))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 mt-3"},[_c('img',{attrs:{"src":'./static/images/takeAction/' + _vm.localContent[1].cards[2].image.fileName,"alt":_vm.localContent[1].cards[2].image.title}}),_vm._v(" "),_c('div',{staticClass:"Blurb Blurb--dark mt-3"},[_c('h2',{staticClass:"Card-title"},[_vm._v(_vm._s(_vm.localContent[1].cards[2].title))]),_vm._v(" "),_c('h3',{staticClass:"Card-subheading mt-3"},[_vm._v(_vm._s(_vm.localContent[1].cards[2].subheadings[0]))]),_vm._v(" "),_c('p',{staticClass:"Blurb-body text-center text-lg-left"},[_vm._v(_vm._s(_vm.localContent[1].cards[2].description))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.localContent[1].cards[2].button.link,"target":"_blank","rel":"noopener"}},[_c('button',{staticClass:"Button Button--dark my-3 mx-auto"},[_vm._v(_vm._s(_vm.localContent[1].cards[2].button.text))])]),_vm._v(" "),_c('p',[_vm._v("Or send your check directly to:")]),_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"Card-subheading mt-3"},[_vm._v(_vm._s(_vm.localContent[1].cards[2].subheadings[1]))]),_vm._v(" "),_c('p',{staticClass:"my-3 text-center text-lg-left"},[_vm._v("Please contact us if you’d like to learn about estate planning or would like to make a gift to the Living with Wolves Endowment.")]),_vm._v(" "),_c('h3',{staticClass:"Card-subheading mt-3"},[_vm._v(_vm._s(_vm.localContent[1].cards[2].subheadings[2]))]),_vm._v(" "),_vm._m(1)])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',{staticClass:"Blurb-blockquote"},[_vm._v("Living with Wolves "),_c('br'),_vm._v("Box 896 "),_c('br'),_vm._v("Sun Valley, Idaho 83353")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center text-lg-left"},[_vm._v("If you would like to speak to someone privately about a donation, please contact us at: "),_c('a',{staticClass:"LinkInline",attrs:{"href":"mailto:info@livingwithwolves.org"}},[_vm._v("info@livingwithwolves.org")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EBxN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FrIG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid NavAttract-container fade-in"},[_c('div',{staticClass:"justify-content-md-center justify-content-lg-end NavAttract-wrapper row"},[_c('div',{staticClass:"col-md-10 col-lg-6 col-xl-5 mr-xl-2 NavAttract"},[_c('h1',{staticClass:"NavAttract-title mb-1 text-center"},[_vm._v("The Hidden Life of Wolves")]),_vm._v(" "),_c('p',{staticClass:"font-italic mb-3 NavAttract-subtitle text-center"},[_vm._v("An interactive exhibit")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"NavAttract-menu"},[_vm._l((_vm.siteConfig.navigation),function(link,i){return _c('li',{key:i,staticClass:"NavAttract-menu-item",on:{"click":function($event){_vm.updateState(link, 'fade')}}},[_c('router-link',{attrs:{"to":link.slug}},[_vm._v(_vm._s(link.title))])],1)}),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_c('p',[_vm._v("Join us in exploring the secrets of one of the world’s most social, intelligent, and misunderstood animals.")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"text-center"},[_vm._v("Presented by "),_c('a',{staticClass:"LinkInline",attrs:{"href":"https://www.livingwithwolves.org/","target":"_blank","rel":"noopener"}},[_c('img',{staticClass:"Logo",attrs:{"src":__webpack_require__("IrbJ"),"alt":"Living with Wolves"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"NavAttract-menu-item"},[_c('a',{attrs:{"href":"https://livingwithwolves.org"}},[_vm._v("Home")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("For millennia, gray wolves, "),_c('em',[_vm._v("Canis lupus")]),_vm._v(", and humans lived side by side often learning and benefitting from one another. Domestic dogs, "),_c('em',[_vm._v("Canis lupus familiaris")]),_vm._v(", are directly descended from wolves. Their innate, devotion, affection, and commitment to family came from their wild wolf ancestors. Once roaming much of the Northern Hemisphere, wolves have been reduced to trace populations, clinging to survival in parts of their former range.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GOW+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RouteContainer"},[_c('app-gallery-section',{attrs:{"sectionIndex":0}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H2ep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hammerjs__ = __webpack_require__("rxKx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_arrow_left__ = __webpack_require__("CFm9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_arrow_right__ = __webpack_require__("vDhf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_arrow_up__ = __webpack_require__("FE82");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_helper__ = __webpack_require__("nAmR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__["a" /* default */]
  },

  props: {
    id: {
      type: String,
      required: true
    },

    imageLs: {
      type: Array,
      required: true
    },

    parentDir: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      currentImageIndex: 0,
      imageLsLocal: [],
      tooltipVisible: false,
      transitionName: 'slide-right--fade',
      imageLsLength: 1
    };
  },


  watch: {
    imageLsLocal: function imageLsLocal(val) {
      this.imageLsLength = val.length;
    }
  },

  created: function created() {
    window.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyup);
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_helper__["a" /* default */]],

  methods: {
    handleKeyup: function handleKeyup(e) {
      if (e.keyCode === 37) {
        this.prevImage();
      } else if (e.keyCode === 39) {
        this.nextImage();
      }
    },
    imgHandler: function imgHandler(e) {
      if (e.target.naturalHeight > e.target.naturalWidth) {
        e.target.className += ' ' + 'Intrinsic-item--portrait';
      }
    },
    preloadImg: function preloadImg(imageLs, parentDir) {
      imageLs.forEach(function (imgObj) {
        var img = new Image();
        img.src = './static/images/' + parentDir + '/' + imgObj.fileName;
      });
    },
    nextImage: function nextImage() {
      this.transitionName = 'slide-left--fade';
      if (this.currentImageIndex >= this.imageLs.length - 1) {
        this.currentImageIndex = 0;
      } else {
        this.currentImageIndex += 1;
      }
    },
    prevImage: function prevImage() {
      this.transitionName = 'slide-right--fade';
      if (this.currentImageIndex <= 0) {
        this.currentImageIndex = this.imageLs.length - 1;
      } else {
        this.currentImageIndex -= 1;
      }
    },
    swipeController: function swipeController(id) {
      var _this = this;

      var slider = document.getElementById(id);
      var mc = new __WEBPACK_IMPORTED_MODULE_0_hammerjs___default.a.Manager(slider, {
        touchAction: 'pan-y'
      });
      var swipeX = new __WEBPACK_IMPORTED_MODULE_0_hammerjs___default.a.Swipe();
      mc.add(swipeX);
      mc.on('swipeleft', function () {
        _this.nextImage();
      });
      mc.on('swiperight', function () {
        _this.prevImage();
      });
    }
  },

  mounted: function mounted() {
    this.swipeController(this.id);
    this.imageLsLocal = this.imageLs;
  }
});

/***/ }),

/***/ "H3lc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RouteContainer"},[_c('app-audio',{attrs:{"src":'./static/audio/' + _vm.landscapeContent.audio}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10 col-md-8 col-lg-8 Blurb text-center text-md-left mx-auto my-3"},[_c('h2',{staticClass:"Blurb-title"},[_vm._v(_vm._s(_vm.landscapeContent.title))]),_vm._v(" "),_c('p',{staticClass:"Blurb-body"},[_vm._v(_vm._s(_vm.landscapeContent.intro))]),_vm._v(" "),_c('p',{staticClass:"Blurb-blockquote mt-3 text-center"},[_vm._v("Select an area to explore ecosystems with and without wolves.")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[(!_vm.landscapeState)?_c('app-background',{key:_vm.generateKey(),attrs:{"backgroundImg":'./static/images/landscape/' + _vm.landscapeContent.maps[0].backgroundImg}}):_c('app-background',{key:_vm.generateKey(),attrs:{"backgroundImg":'./static/images/landscape/' + _vm.landscapeContent.maps[1].backgroundImg}})],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('app-landcape-map')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hh58":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gallery_gallery_section__ = __webpack_require__("+8s/");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'packAnatomy',

  components: {
    appGallerySection: __WEBPACK_IMPORTED_MODULE_0__gallery_gallery_section__["a" /* default */]
  }
});

/***/ }),

/***/ "I+tC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"container-fluid Navbar"},[_c('transition',{attrs:{"name":"slideIn"}},[(_vm.isOpen)?_c('div',{staticClass:"Navbar-menu Navbar-menu--mobile d-lg-none",style:({ backgroundImage: 'url(./static/images/' + 'navbar-bg.jpg' + ')' })},[_c('ul',{staticClass:"Navbar-menu-list Navbar-menu-list--mobile"},[_c('li',{on:{"click":_vm.toggleMenu}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Intro")])],1),_vm._v(" "),_c('li',{on:{"click":_vm.toggleMenu}},[_c('router-link',{attrs:{"to":"/wolves-101"}},[_vm._v("Wolves 101")])],1),_vm._v(" "),_c('li',{on:{"click":_vm.toggleMenu}},[_c('router-link',{attrs:{"to":"/explore-the-wolf"}},[_vm._v("Explore the Wolf")])],1),_vm._v(" "),_c('li',{on:{"click":_vm.toggleMenu}},[_c('router-link',{attrs:{"to":"/ecosystem"}},[_vm._v("Ecosystem")])],1),_vm._v(" "),_c('li',{on:{"click":_vm.toggleMenu}},[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1),_vm._v(" "),_c('li',{on:{"click":_vm.toggleMenu}},[_c('router-link',{attrs:{"to":"/take-action"}},[_vm._v("Take Action")])],1),_vm._v(" "),_c('li',{on:{"click":_vm.toggleMenu}},[_c('a',{attrs:{"href":"https://livingwithwolves.org"}},[_vm._v("Home")])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-4 col-sm-6 col-lg-9 col-xl-8 ml-auto Navbar-menu"},[_c('div',{staticClass:"Navbar-menu-toggle d-lg-none",on:{"click":function($event){_vm.toggleMenu()}}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.isOpen)?_c('icon',{key:'open',attrs:{"name":"bars","scale":"1.5"}}):_c('icon',{key:'close',attrs:{"name":"close","scale":"1.5"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"Navbar-menu Navbar-menu--desktop d-none d-lg-flex"},[_c('ul',{staticClass:"Navbar-menu-list Navbar-menu-list--desktop"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Intro")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/wolves-101"}},[_vm._v("Wolves 101")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/explore-the-wolf"}},[_vm._v("Explore the Wolf")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/ecosystem"}},[_vm._v("Ecosystem")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/take-action"}},[_vm._v("Take Action")])],1),_vm._v(" "),_vm._m(1)])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-8 col-sm-6 col-lg-3 col-xl-3 pr-xl-5"},[_c('a',{attrs:{"href":"https://livingwithwolves.org"}},[_c('img',{attrs:{"src":__webpack_require__("IrbJ"),"alt":"Living with Wolves"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://livingwithwolves.org"}},[_vm._v("Home")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IrbJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "J+zU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_landscape_vue__ = __webpack_require__("ajzF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663f3eca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_landscape_vue__ = __webpack_require__("H3lc");
function injectStyle (ssrContext) {
  __webpack_require__("oado")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-663f3eca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_landscape_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663f3eca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_landscape_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JER+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_audio__ = __webpack_require__("aSYd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_background__ = __webpack_require__("QtNj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_navAttract__ = __webpack_require__("K5OD");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appAudio: __WEBPACK_IMPORTED_MODULE_0__partials_audio__["a" /* default */],
    appBackground: __WEBPACK_IMPORTED_MODULE_1__partials_background__["a" /* default */],
    appNavAttract: __WEBPACK_IMPORTED_MODULE_2__partials_navAttract__["a" /* default */]
  },

  computed: {
    sharedContent: function sharedContent() {
      return this.$store.getters.sharedContent;
    }
  },

  created: function created() {
    var _this = this;

    this.$http.get('./static/images/primary-bg-blur.jpg');
    this.$http.get('./static/images/explore/wolf-bg-blur.jpg');
    this.$http.get('./static/images/landscape/landscape-without-bg-blur.jpg');
    this.$http.get('./static/data/gallery.json').then(function (response) {
      return response;
    }).then(function (data) {
      data.body.sections.forEach(function (section) {
        section.previewImages.forEach(function (img) {
          _this.$http.get('./static/images/gallery' + '/' + section.directory + '/' + img.fileName);
        });
      });
    }).catch(function (err) {
      console.log(err);
    });
  }
});

/***/ }),

/***/ "K5OD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navAttract_vue__ = __webpack_require__("jtg4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ffc98a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navAttract_vue__ = __webpack_require__("FrIG");
function injectStyle (ssrContext) {
  __webpack_require__("mRls")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ffc98a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navAttract_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ffc98a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navAttract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LHKt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__ = __webpack_require__("UG0K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afde558_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__ = __webpack_require__("I+tC");
function injectStyle (ssrContext) {
  __webpack_require__("SXpd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6afde558"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afde558_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M/2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RouteContainer"},[_c('app-background',{attrs:{"backgroundImg":'./static/images/' + _vm.sharedContent.backgroundImgBlur}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center mt-5"},[_c('div',{staticClass:"col-md-6"},[_c('img',{attrs:{"src":'./static/images/about/' + _vm.aboutContent.introImage.fileName,"alt":_vm.aboutContent.introImage.title,"title":_vm.aboutContent.introImage.title}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"Blurb"},[_c('h1',{staticClass:"Blurb-title"},[_vm._v(_vm._s(_vm.aboutContent.title))]),_vm._v(" "),_c('p',{staticClass:"Blurb-body"},[_vm._v(_vm._s(_vm.aboutContent.intro))])])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid mt-5 Article-wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row Article"},[_vm._l((_vm.aboutContent.articles),function(article,i){return _c('div',{key:i,staticClass:"col-md-8 mx-auto py-3"},[_c('h2',{staticClass:"Article-title"},[_vm._v(_vm._s(article.heading))]),_vm._v(" "),_c('p',{staticClass:"Article-body"},[_vm._v("\n            "+_vm._s(article.body)+" Learn more at "),_c('a',{staticClass:"LinkInline",attrs:{"href":"https://www.livingwithwolves.org/","target":"_blank","rel":"noopener"}},[_vm._v("livingwithwolves.org")]),_vm._v(".\n          ")])])}),_vm._v(" "),_vm._m(0)],2)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 mx-auto"},[_c('p',[_vm._v("To purchase the Dutcher’s images visit "),_c('a',{staticClass:"LinkInline",attrs:{"href":"https://www.livingwithwolves.org/national-geographic/","target":"_blank","rel":"noopener"}},[_vm._v("National Geographic Creative.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224824e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("O6Ti");
function injectStyle (ssrContext) {
  __webpack_require__("cT9J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224824e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__("wtEF");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__webpack_require__("8y8H");

// NOTE: promise polyfill required for Vuex use in IE
__webpack_require__("MU8w");

__webpack_require__("erTq");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  document.title = to.meta.title(to);
  next();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  store: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */]
});

/***/ }),

/***/ "O6Ti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-overflow': _vm.currentRouteIsGallery },attrs:{"id":"app"}},[(!_vm.currentRouteIsHome)?_c('app-navbar'):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OhQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RouteContainer"},[_c('app-gallery-section',{attrs:{"sectionIndex":3}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PhBp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gallery_slide_vue__ = __webpack_require__("mwqO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3596cee4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gallery_slide_vue__ = __webpack_require__("+1wc");
function injectStyle (ssrContext) {
  __webpack_require__("aW7a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3596cee4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gallery_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3596cee4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gallery_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QtNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_background_vue__ = __webpack_require__("UKqF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30e68776_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_background_vue__ = __webpack_require__("mrPb");
function injectStyle (ssrContext) {
  __webpack_require__("6kjB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30e68776"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_background_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30e68776_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_background_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SVml":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_take_action_vue__ = __webpack_require__("tElb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e798dcc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_take_action_vue__ = __webpack_require__("DKgP");
function injectStyle (ssrContext) {
  __webpack_require__("VZdw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e798dcc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_take_action_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e798dcc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_take_action_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SXpd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UDEO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RouteContainer"},[_c('app-gallery-section',{attrs:{"sectionIndex":4}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UG0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_data_site_config_json__ = __webpack_require__("DIQl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_data_site_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_data_site_config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_bars__ = __webpack_require__("inJg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_close__ = __webpack_require__("nZeE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__["a" /* default */]
  },

  data: function data() {
    return {
      siteConfig: __WEBPACK_IMPORTED_MODULE_0__static_data_site_config_json___default.a,
      isOpen: false
    };
  },


  computed: {
    currentRoute: function currentRoute() {
      return this.$route.path;
    },
    currentRouteIsHome: function currentRouteIsHome() {
      return this.$route.path === '/';
    }
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    updateAndClose: function updateAndClose(link, animation) {
      this.toggleMenu();
      this.updateState(link, animation);
    },
    updateState: function updateState(link, animation) {
      var parent = link.defaultView.parent;
      var view = link.defaultView.view;
      var payload = {
        parent: parent,
        updates: {
          currentDetail: null,
          currentView: view,
          animation: animation || 'fade'
        }
      };
      if (parent && view !== '') {
        this.$store.dispatch('updateProps', payload);
      }
    }
  }
});

/***/ }),

/***/ "UKqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'background',

  props: {
    backgroundImg: String
  }
});

/***/ }),

/***/ "VO4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hammerjs__ = __webpack_require__("rxKx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_helper__ = __webpack_require__("nAmR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'landscapeMap',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_helper__["a" /* default */]],

  data: function data() {
    return {
      currentDetail: '',
      pingHiddenWithout: null,
      pingHiddenWith: null,
      withoutWolves: null
    };
  },


  computed: {
    isNarrowScreen: function isNarrowScreen() {
      return window.innerWidth < 768;
    },
    landscapeContent: function landscapeContent() {
      return this.$store.getters.landscapeContent;
    },
    mapDescription: function mapDescription() {
      return this.withoutWolves ? '' : '';
    },
    withoutWolvesMapObj: function withoutWolvesMapObj() {
      return this.$store.getters.landscapeContent.maps[0];
    },
    withWolvesMapObj: function withWolvesMapObj() {
      return this.$store.getters.landscapeContent.maps[1];
    },
    woDetails: function woDetails() {
      return this.$store.getters.landscapeContent.maps[0].mapDetails;
    },
    wwDetails: function wwDetails() {
      return this.$store.getters.landscapeContent.maps[1].mapDetails;
    }
  },

  methods: {
    swipeController: function swipeController(id) {
      var _this = this;

      var map = document.getElementById(id);
      var mc = new __WEBPACK_IMPORTED_MODULE_0_hammerjs___default.a.Manager(map, {
        touchAction: 'pan-y'
      });
      var swipeX = new __WEBPACK_IMPORTED_MODULE_0_hammerjs___default.a.Swipe();
      mc.add(swipeX);
      mc.on('swipeleft', function () {
        _this.withoutWolves = !_this.withoutWolves;
      });
      mc.on('swiperight', function () {
        _this.withoutWolves = !_this.withoutWolves;
      });
    }
  },

  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getLocalData', 'landscape');
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      if (_this2.pingHiddenWithout === null) {
        _this2.pingHiddenWithout = true;
      }
      if (_this2.pingHiddenWith === null) {
        _this2.pingHiddenWith = true;
      }
    }, 1000 * 10);

    if (this.isNarrowScreen) {
      this.withoutWolves = true;
      this.swipeController('ImageMap-without');
      this.swipeController('ImageMap-with');
    }
  }
});

/***/ }),

/***/ "VZdw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VmZH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wolf-explore--1110.30c6d48.jpg";

/***/ }),

/***/ "XfxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.clazz,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path){return _c('path',_vm._b({},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon){return _c('polygon',_vm._b({},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.icon.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y7sP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gallery_gallery_section__ = __webpack_require__("+8s/");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WolvesAndPeople',

  components: {
    appGallerySection: __WEBPACK_IMPORTED_MODULE_0__gallery_gallery_section__["a" /* default */]
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_routes_index__ = __webpack_require__("65Hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_routes_explore_the_wolf__ = __webpack_require__("gjgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_routes_wolves_101__ = __webpack_require__("t9Ol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_routes_pack_anatomy__ = __webpack_require__("og5L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_routes_meet_the_wolf__ = __webpack_require__("igh8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_routes_social_behavior__ = __webpack_require__("rtvI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_routes_the_benefits_of_wolves__ = __webpack_require__("eGXR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_routes_wolves_and_people__ = __webpack_require__("2NMG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_routes_landscape__ = __webpack_require__("J+zU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_routes_about__ = __webpack_require__("9NPo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_routes_take_action__ = __webpack_require__("SVml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json__ = __webpack_require__("DIQl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json__);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_2__components_routes_index__["a" /* default */],
    meta: {
      title: function title(route) {
        return __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default.a.siteTitle;
      }
    }
  }, {
    path: '/explore-the-wolf',
    name: 'Explore the Wolf',
    component: __WEBPACK_IMPORTED_MODULE_3__components_routes_explore_the_wolf__["a" /* default */],
    meta: {
      title: function title(route) {
        return route.name + ' - ' + __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default.a.siteTitle;
      }
    }
  }, {
    path: '/wolves-101',
    name: 'wolves-101',
    component: __WEBPACK_IMPORTED_MODULE_4__components_routes_wolves_101__["a" /* default */],
    meta: {
      title: function title(route) {
        return route.name + ' - ' + __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default.a.siteTitle;
      }
    }
  }, {
    path: '/wolves-101/meet-the-wolf',
    name: 'Meet the Wolf',
    component: __WEBPACK_IMPORTED_MODULE_6__components_routes_meet_the_wolf__["a" /* default */],
    meta: {
      title: function title(route) {
        return 'wolves-101: ' + route.name + ' - ' + __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default.a.siteTitle;
      }
    }
  }, {
    path: '/wolves-101/pack-anatomy',
    name: 'Pack Anatomy',
    component: __WEBPACK_IMPORTED_MODULE_5__components_routes_pack_anatomy__["a" /* default */],
    meta: {
      title: function title(route) {
        return 'wolves-101: ' + route.name + ' - ' + __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default.a.siteTitle;
      }
    }
  }, {
    path: '/wolves-101/social-behavior',
    name: 'Social Behavior',
    component: __WEBPACK_IMPORTED_MODULE_7__components_routes_social_behavior__["a" /* default */],
    meta: {
      title: function title(route) {
        return 'wolves-101: ' + route.name + ' - ' + __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default.a.siteTitle;
      }
    }
  }, {
    path: '/wolves-101/the-benefits-of-wolves',
    name: 'The Benefits of Wolves',
    component: __WEBPACK_IMPORTED_MODULE_8__components_routes_the_benefits_of_wolves__["a" /* default */],
    meta: {
      title: function title(route) {
        return 'wolves-101: ' + route.name + ' - ' + __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default.a.siteTitle;
      }
    }
  }, {
    path: '/wolves-101/wolves-and-people',
    name: 'Wolves and People',
    component: __WEBPACK_IMPORTED_MODULE_9__components_routes_wolves_and_people__["a" /* default */],
    meta: {
      title: function title(route) {
        return 'wolves-101: ' + route.name + ' - ' + __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default.a.siteTitle;
      }
    }
  }, {
    path: '/ecosystem',
    name: 'Ecosystem',
    component: __WEBPACK_IMPORTED_MODULE_10__components_routes_landscape__["a" /* default */],
    meta: {
      title: function title(route) {
        return route.name + ' - ' + __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default.a.siteTitle;
      }
    }
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_11__components_routes_about__["a" /* default */],
    meta: {
      title: function title(route) {
        return route.name + ' - ' + __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default.a.siteTitle;
      }
    }
  }, {
    path: '/take-action',
    name: 'Take Action',
    component: __WEBPACK_IMPORTED_MODULE_12__components_routes_take_action__["a" /* default */],
    meta: {
      title: function title(route) {
        return route.name + ' - ' + __WEBPACK_IMPORTED_MODULE_13__static_data_site_config_json___default.a.siteTitle;
      }
    }
  }],

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
}));

/***/ }),

/***/ "aLra":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_volume_off__ = __webpack_require__("CHnS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_volume_up__ = __webpack_require__("vXMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_helper__ = __webpack_require__("nAmR");
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */]
  },

  props: ['src'],

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_helper__["a" /* default */]],

  data: function data() {
    return {
      isPlaying: false,
      audioId: null
    };
  },


  computed: {
    audio: function audio() {
      return this.getAudio(this.audioId);
    }
  },

  methods: {
    getAudio: function getAudio(el) {
      return document.getElementById(el);
    },
    increaseVolume: function increaseVolume() {
      var vm = this;
      var timer = setInterval(function () {
        if (vm.audio.volume < 0.9) {
          vm.audio.volume += 0.01;
        } else {
          clearTimeout(timer);
        }
      }, 50);
    },
    initAudio: function initAudio() {
      this.audio.volume = 0;
      this.audio.play();
      this.increaseVolume();
    },
    toggleAudio: function toggleAudio() {
      if (this.isPlaying) {
        this.audio.pause();
      } else {
        this.audio.play();
      }
    }
  },

  created: function created() {
    this.audioId = this.generateKey();
  },
  mounted: function mounted() {
    var _this = this;

    this.audio.addEventListener('play', function () {
      _this.isPlaying = true;
    });
    this.audio.addEventListener('pause', function () {
      _this.isPlaying = false;
    });
  }
});

/***/ }),

/***/ "aSYd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_audio_vue__ = __webpack_require__("aLra");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_408f3ebe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_audio_vue__ = __webpack_require__("tQIp");
function injectStyle (ssrContext) {
  __webpack_require__("28lb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-408f3ebe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_audio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_408f3ebe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_audio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aW7a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ajzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_audio__ = __webpack_require__("aSYd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_background__ = __webpack_require__("QtNj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__landscape_landscape_map__ = __webpack_require__("5lvk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_helper__ = __webpack_require__("nAmR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appAudio: __WEBPACK_IMPORTED_MODULE_0__partials_audio__["a" /* default */],
    appBackground: __WEBPACK_IMPORTED_MODULE_1__partials_background__["a" /* default */],
    appLandcapeMap: __WEBPACK_IMPORTED_MODULE_2__landscape_landscape_map__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_helper__["a" /* default */]],

  data: function data() {
    return {
      landscapeState: false
    };
  },


  computed: {
    landscapeContent: function landscapeContent() {
      return this.$store.getters.landscapeContent;
    }
  },

  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getLocalData', 'landscape');
  }
});

/***/ }),

/***/ "bRHh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cE5y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_audio__ = __webpack_require__("aSYd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_background__ = __webpack_require__("QtNj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gallery_gallery_slide__ = __webpack_require__("PhBp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_home__ = __webpack_require__("8AWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jump_js__ = __webpack_require__("q7+D");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gallerySection',

  components: {
    appAudio: __WEBPACK_IMPORTED_MODULE_0__partials_audio__["a" /* default */],
    appBackground: __WEBPACK_IMPORTED_MODULE_1__partials_background__["a" /* default */],
    appGallerySlide: __WEBPACK_IMPORTED_MODULE_2__gallery_gallery_slide__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */]
  },

  data: function data() {
    return {
      menuIsOpen: false,
      isAnimating: true,
      waypoint: null
    };
  },


  props: {
    sectionIndex: Number
  },

  computed: {
    galleryContent: function galleryContent() {
      return this.$store.getters.galleryContent;
    },
    sharedContent: function sharedContent() {
      return this.$store.getters.sharedContent;
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_clickaway__["mixin"]],

  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getLocalData', 'gallery');
  },
  created: function created() {
    window.onbeforeunload = function () {
      return window.scrollTo(0, 0);
    };
  },
  mounted: function mounted() {
    var _this = this;

    /* eslint-disable */
    // require('waypoints/lib/noframework.waypoints')
    // setTimeout(() => {
    //   const vm = this;
    //   const slides = document.getElementsByClassName('Slide')
    //   console.log(slides)
    //   Array.prototype.forEach.call(slides, function (el, i) {
    //     vm.waypoint = new Waypoint({
    //       element: el,
    //       handler: function (direction) {
    //         if (direction === 'down') {
    //           const nextSection = slides[i + 1].id
    //           jump('#' + nextSection, {
    //             offset: 0
    //           })
    //         }
    //       },
    //       offset: function () {
    //         // following returns 'bottom-in-view' + 10px
    //         return (this.context.innerHeight() - this.adapter.outerHeight()) - 10
    //       },
    //       // offset: 'bottom-in-view',
    //       continuous: false
    //     })
    //   })
    // }, 1000)
    if (this.$route.query.id) {
      setTimeout(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_jump_js__["a" /* default */])('#' + _this.$route.query.id);
      }, 1000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Waypoint.destroyAll()
  },


  methods: {
    closeMenu: function closeMenu() {
      this.menuIsOpen = false;
    },


    debouncedScroll: _.throttle(function (e) {
      // NOTE: mousewheel delta for IE
      var delta = e.wheelDelta * -1 || e.deltaY;
      var nextSection = this.galleryContent.sections[this.sectionIndex].subsections[0].id;
      if (delta > 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_jump_js__["a" /* default */])('#' + nextSection, {
          offset: -78
        });
      }
    }, 1000, {
      leading: true,
      trailing: false
    }),

    jumpToId: function jumpToId(selector) {
      // this.waypoint.group.waypoints.forEach(point => point.disable())
      var id = '#' + selector;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_jump_js__["a" /* default */])(id, {
        offset: -78
        // callback: () => this.waypoint.group.waypoints.forEach(point => point.enable())
      });
    }
  }
});

/***/ }),

/***/ "cT9J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ "eGXR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_the_benefits_of_wolves_vue__ = __webpack_require__("qieW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330e4abe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_the_benefits_of_wolves_vue__ = __webpack_require__("OhQa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_the_benefits_of_wolves_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330e4abe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_the_benefits_of_wolves_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "erTq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g2ZE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-5"},[(_vm.isNarrowScreen)?_c('div',{staticClass:"col text-center"},[_c('div',{staticClass:"Blurb pt-0 px-0 pb-3"},[_c('div',{staticClass:"Blurb-blockquote"},[_c('h2',[_vm._v(_vm._s(_vm.withoutWolves ? 'A World without Wolves' : 'A World with Wolves'))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.withoutWolves ? 'Yellowstone without wolves 1926 – 1995' : 'Yellowstone with wolves 1995 – present'))])]),_vm._v(" "),_c('h2',[_vm._v("Swipe left/right to Explore")]),_vm._v(" "),_c('p',[_vm._v("Tap the Ecosystem to Learn More")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withoutWolves === null || _vm.withoutWolves),expression:"withoutWolves === null || withoutWolves"}],key:'withWolves',staticClass:"col-md-6 ImageMap-container"},[(!_vm.isNarrowScreen)?_c('div',{staticClass:"Blurb Blurb-blockquote"},[_c('h2',[_vm._v("A World Without Wolves")]),_vm._v(" "),_c('p',[_vm._v("Yellowstone without wolves 1926 – 1995")])]):_vm._e(),_vm._v(" "),_c('svg',{staticClass:"ImageMap ImageMap--ie--ecosystem",staticStyle:{"enable-background":"new 0 0 508 1100"},attrs:{"id":"ImageMap-without","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 508 1100","xml:space":"preserve"},on:{"mouseover":function($event){_vm.pingHiddenWithout = false},"mouseout":function($event){_vm.pingHiddenWithout = true}}},[_c('image',{staticStyle:{"overflow":"visible"},attrs:{"width":"508","height":"1100","xlink:href":__webpack_require__("nVIi")}}),_vm._v(" "),_c('g',{attrs:{"id":"wo-understory"},on:{"mouseover":function($event){_vm.currentDetail = 'wo-understory'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"99.5","y":"330","width":"199.5","height":"53.5"}})]),_vm._v(" "),_c('g',{attrs:{"id":"wo-erosion"},on:{"mouseover":function($event){_vm.currentDetail = 'wo-erosion'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"307","y":"586","width":"128","height":"73"}})]),_vm._v(" "),_c('g',{attrs:{"id":"wo-water"},on:{"mouseover":function($event){_vm.currentDetail = 'wo-water'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"342","y":"682","width":"128","height":"73"}})]),_vm._v(" "),_c('g',{attrs:{"id":"wo-coyote"},on:{"mouseover":function($event){_vm.currentDetail = 'wo-coyote'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"307","y":"490","width":"128","height":"73"}})]),_vm._v(" "),_c('g',{attrs:{"id":"wo-elk"},on:{"mouseover":function($event){_vm.currentDetail = 'wo-elk'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"40","y":"667.5","width":"128","height":"73"}})]),_vm._v(" "),_c('g',{attrs:{"id":"wo-aspen"},on:{"mouseover":function($event){_vm.currentDetail = 'wo-aspen'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"y":"407","width":"109.5","height":"73"}})])]),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--wo-elk",class:{ 'ping--continuous': !_vm.pingHiddenWithout, 'is-hidden': _vm.pingHiddenWithout }}),_vm._v(" "),(_vm.currentDetail === 'wo-elk')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--wo-elk",class:{ 'is-shown': !_vm.pingHiddenWithout }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.woDetails[0].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.woDetails[0].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--wo-aspen",class:{ 'ping--continuous': !_vm.pingHiddenWithout, 'is-hidden': _vm.pingHiddenWithout }}),_vm._v(" "),(_vm.currentDetail === 'wo-aspen')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--wo-aspen",class:{ 'is-shown': !_vm.pingHiddenWithout }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.woDetails[1].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.woDetails[1].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--wo-understory",class:{ 'ping--continuous': !_vm.pingHiddenWithout, 'is-hidden': _vm.pingHiddenWithout }}),_vm._v(" "),(_vm.currentDetail === 'wo-understory')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--wo-understory",class:{ 'is-shown': !_vm.pingHiddenWithout }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.woDetails[2].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.woDetails[2].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--wo-erosion",class:{ 'ping--continuous': !_vm.pingHiddenWithout, 'is-hidden': _vm.pingHiddenWithout }}),_vm._v(" "),(_vm.currentDetail === 'wo-erosion')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--wo-erosion",class:{ 'is-shown': !_vm.pingHiddenWithout }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.woDetails[3].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.woDetails[3].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--wo-coyote",class:{ 'ping--continuous': !_vm.pingHiddenWithout, 'is-hidden': _vm.pingHiddenWithout }}),_vm._v(" "),(_vm.currentDetail === 'wo-coyote')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--wo-coyote",class:{ 'is-shown': !_vm.pingHiddenWithout }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.woDetails[4].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.woDetails[4].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--wo-water",class:{ 'ping--continuous': !_vm.pingHiddenWithout, 'is-hidden': _vm.pingHiddenWithout }}),_vm._v(" "),(_vm.currentDetail === 'wo-water')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--wo-water",class:{ 'is-shown': !_vm.pingHiddenWithout }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.woDetails[5].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.woDetails[5].caption))])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withoutWolves === null || !_vm.withoutWolves),expression:"withoutWolves === null || !withoutWolves"}],key:'withoutWolves',staticClass:"col-md-6 ImageMap-container"},[(!_vm.isNarrowScreen)?_c('div',{staticClass:"Blurb Blurb-blockquote"},[_c('h2',[_vm._v("A World With Wolves")]),_vm._v(" "),_c('p',[_vm._v("Yellowstone with wolves 1995 – present")])]):_vm._e(),_vm._v(" "),_c('svg',{staticClass:"ImageMap ImageMap--ie--ecosystem",staticStyle:{"enable-background":"new 0 0 508 1100"},attrs:{"id":"ImageMap-with","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 508 1100","xml:space":"preserve"},on:{"mouseover":function($event){_vm.pingHiddenWith = false},"mouseout":function($event){_vm.pingHiddenWith = true}}},[_c('image',{staticStyle:{"overflow":"visible"},attrs:{"width":"508","height":"1100","xlink:href":__webpack_require__("CFg9")}}),_vm._v(" "),_c('g',{attrs:{"id":"ww-understory"},on:{"mouseover":function($event){_vm.currentDetail = 'ww-understory'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"118.5","y":"337","width":"199.5","height":"53.5"}})]),_vm._v(" "),_c('g',{attrs:{"id":"ww-beavers"},on:{"mouseover":function($event){_vm.currentDetail = 'ww-beavers'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"278.3","y":"610","width":"163.3","height":"97.3"}})]),_vm._v(" "),_c('g',{attrs:{"id":"ww-coyote"},on:{"mouseover":function($event){_vm.currentDetail = 'ww-coyote'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"154.8","y":"390.5","width":"163.3","height":"60"}})]),_vm._v(" "),_c('g',{attrs:{"id":"ww-waterQuality"},on:{"mouseover":function($event){_vm.currentDetail = 'ww-waterQuality'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"361","y":"790","width":"128","height":"52.7"}})]),_vm._v(" "),_c('g',{attrs:{"id":"ww-willows"},on:{"mouseover":function($event){_vm.currentDetail = 'ww-willows'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"135","y":"648.7","width":"143.3","height":"83.3"}})]),_vm._v(" "),_c('g',{attrs:{"id":"ww-carrion"},on:{"mouseover":function($event){_vm.currentDetail = 'ww-carrion'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"265.3","y":"848.7","width":"143.3","height":"83.3"}})]),_vm._v(" "),_c('g',{attrs:{"id":"ww-elk"},on:{"mouseover":function($event){_vm.currentDetail = 'ww-elk'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"337","y":"365","width":"152","height":"73"}})]),_vm._v(" "),_c('g',{attrs:{"id":"ww-nestingBirds"},on:{"mouseover":function($event){_vm.currentDetail = 'ww-nestingBirds'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"y":"546.3","width":"152","height":"73"}})]),_vm._v(" "),_c('g',{attrs:{"id":"ww-aspen"},on:{"mouseover":function($event){_vm.currentDetail = 'ww-aspen'},"mouseout":function($event){_vm.currentDetail = ''}}},[_c('rect',{staticClass:"ImageMap-detail",attrs:{"x":"19","y":"414","width":"109.5","height":"73"}})])]),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--ww-elk",class:{ 'ping--continuous': !_vm.pingHiddenWith, 'is-hidden': _vm.pingHiddenWith }}),_vm._v(" "),(_vm.currentDetail === 'ww-elk')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--ww-elk",class:{ 'is-shown': !_vm.pingHiddenWith }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.wwDetails[0].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.wwDetails[0].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--ww-aspen",class:{ 'ping--continuous': !_vm.pingHiddenWith, 'is-hidden': _vm.pingHiddenWith }}),_vm._v(" "),(_vm.currentDetail === 'ww-aspen')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--wo-aspen",class:{ 'is-shown': !_vm.pingHiddenWith }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.wwDetails[1].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.wwDetails[1].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--ww-understory",class:{ 'ping--continuous': !_vm.pingHiddenWith, 'is-hidden': _vm.pingHiddenWith }}),_vm._v(" "),(_vm.currentDetail === 'ww-understory')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--wo-understory",class:{ 'is-shown': !_vm.pingHiddenWith }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.wwDetails[2].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.wwDetails[2].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--ww-nestingBirds",class:{ 'ping--continuous': !_vm.pingHiddenWith, 'is-hidden': _vm.pingHiddenWith }}),_vm._v(" "),(_vm.currentDetail === 'ww-nestingBirds')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--ww-nestingBirds",class:{ 'is-shown': !_vm.pingHiddenWith }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.wwDetails[3].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.wwDetails[3].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--ww-coyote",class:{ 'ping--continuous': !_vm.pingHiddenWith, 'is-hidden': _vm.pingHiddenWith }}),_vm._v(" "),(_vm.currentDetail === 'ww-coyote')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--ww-coyote",class:{ 'is-shown': !_vm.pingHiddenWith }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.wwDetails[4].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.wwDetails[4].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--ww-willows",class:{ 'ping--continuous': !_vm.pingHiddenWith, 'is-hidden': _vm.pingHiddenWith }}),_vm._v(" "),(_vm.currentDetail === 'ww-willows')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--ww-willows",class:{ 'is-shown': !_vm.pingHiddenWith }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.wwDetails[5].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.wwDetails[5].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--ww-beavers",class:{ 'ping--continuous': !_vm.pingHiddenWith, 'is-hidden': _vm.pingHiddenWith }}),_vm._v(" "),(_vm.currentDetail === 'ww-beavers')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--ww-beavers",class:{ 'is-shown': !_vm.pingHiddenWith }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.wwDetails[6].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.wwDetails[6].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--ww-carrion",class:{ 'ping--continuous': !_vm.pingHiddenWith, 'is-hidden': _vm.pingHiddenWith }}),_vm._v(" "),(_vm.currentDetail === 'ww-carrion')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--ww-carrion",class:{ 'is-shown': !_vm.pingHiddenWith }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.wwDetails[7].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.wwDetails[7].caption))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:" Hotspot Hotspot--ww-waterQuality",class:{ 'ping--continuous': !_vm.pingHiddenWith, 'is-hidden': _vm.pingHiddenWith }}),_vm._v(" "),(_vm.currentDetail === 'ww-waterQuality')?_c('div',{staticClass:"Tooltip Tooltip--ecosystem Tooltip--ww-waterQuality",class:{ 'is-shown': !_vm.pingHiddenWith }},[_c('h3',{staticClass:"Tooltip-title"},[_vm._v(_vm._s(_vm.wwDetails[8].name))]),_vm._v(" "),_c('p',{staticClass:"Tooltip-subtitle"},[_vm._v(_vm._s(_vm.wwDetails[8].caption))])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gRrK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Section"},[_c('app-background',{attrs:{"backgroundImg":'./static/images/' + _vm.sharedContent.backgroundImgBlur}}),_vm._v(" "),_c('app-audio',{attrs:{"src":'./static/audio/' + _vm.galleryContent.sections[_vm.sectionIndex].audio}}),_vm._v(" "),_c('div',{staticClass:"container Section-map",attrs:{"id":"home"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-3"},[_c('div',{staticClass:"ButtonIcon ButtonIcon--small ButtonIcon--light mx-auto",attrs:{"title":"Return to Wolves 101"}},[_c('router-link',{attrs:{"to":"/wolves-101"}},[_c('icon',{attrs:{"name":"home","scale":".85"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-xl-8 mx-auto mt-3"},[_c('div',{staticClass:"Blurb",class:{ 'is-blurred': _vm.menuIsOpen }},[_c('h2',{staticClass:"Blurb-title text-center"},[_vm._v("\n            "+_vm._s(_vm.galleryContent.sections[_vm.sectionIndex].name || '')+"\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.galleryContent.sections[_vm.sectionIndex].description || '')+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"row Section-map-preview"},[_c('div',{staticClass:"col Section-map-wrapper"},_vm._l((_vm.galleryContent.sections[_vm.sectionIndex].subsections),function(subsection,i){return _c('div',{key:i,staticClass:"Section-map-img",class:[ 'Section-map-img--' + i, { 'is-blurred': _vm.menuIsOpen } ]},[_c('img',{attrs:{"src":'./static/images/gallery/' + _vm.galleryContent.sections[_vm.sectionIndex].directory + '/' + subsection.previewImage,"alt":subsection.name,"title":subsection.name},on:{"click":function($event){_vm.jumpToId(subsection.id)}}})])}))]),_vm._v(" "),_c('div',{staticClass:"row Contents Contents--centered"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.menuIsOpen)?_c('div',{staticClass:"col-md-5 mx-auto Contents-container"},[_c('ol',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.closeMenu),expression:"closeMenu"}],staticClass:"Contents-menu"},_vm._l((_vm.galleryContent.sections[_vm.sectionIndex].subsections),function(subsection,i){return _c('li',{key:i,staticClass:"Contents-menu-item",on:{"click":function($event){_vm.jumpToId(subsection.id)}}},[_vm._v("\n            "+_vm._s(subsection.name)+"\n          ")])}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 mx-auto"},[_c('button',{staticClass:"Button Button--dark mx-auto",on:{"click":function($event){_vm.menuIsOpen = !_vm.menuIsOpen}}},[_vm._v("\n        "+_vm._s((_vm.menuIsOpen) ? 'Hide Contents' : 'Show Contents')+"\n      ")])])],1)]),_vm._v(" "),_vm._l((_vm.galleryContent.sections[_vm.sectionIndex].subsections),function(subsection,i){return _c('app-gallery-slide',{key:subsection + i,attrs:{"sectionIndex":_vm.sectionIndex,"slideIndex":i}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gjgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_explore_the_wolf_vue__ = __webpack_require__("m640");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfbf3e10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_explore_the_wolf_vue__ = __webpack_require__("CN8O");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_explore_the_wolf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfbf3e10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_explore_the_wolf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "huB6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wolf_detail_vue__ = __webpack_require__("7WPe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cb894a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wolf_detail_vue__ = __webpack_require__("6vV4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wolf_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cb894a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wolf_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "igh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_meet_the_wolf_vue__ = __webpack_require__("q512");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071c1a54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_meet_the_wolf_vue__ = __webpack_require__("GOW+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_meet_the_wolf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071c1a54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_meet_the_wolf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jtg4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_data_site_config_json__ = __webpack_require__("DIQl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_data_site_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_data_site_config_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      siteConfig: __WEBPACK_IMPORTED_MODULE_0__static_data_site_config_json___default.a
    };
  },


  methods: {
    updateState: function updateState(link, animation) {
      var parent = link.defaultView.parent;
      var view = link.defaultView.view;
      var payload = {
        parent: parent,
        updates: {
          currentDetail: null,
          currentView: view,
          animation: animation || 'fade'
        }
      };
      if (parent && view !== '') {
        this.$store.dispatch('updateProps', payload);
      }
    }
  }
});

/***/ }),

/***/ "km2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.imageLsLength > 1)?_c('div',{staticClass:"col-1 Slider-button"},[_c('div',{staticClass:"ButtonIcon ButtonIcon--oval ButtonIcon--light",attrs:{"title":"Previous Image"},on:{"click":function($event){_vm.prevImage()}}},[_c('icon',{attrs:{"name":"arrow-left","scale":".85"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-10 mx-auto"},[_c('div',{staticClass:"Slider-wrapper Intrinsic-wrapper Intrinsic-wrapper--3x2",attrs:{"id":_vm.id},on:{"mouseover":function($event){_vm.preloadImg(_vm.imageLs, _vm.parentDir)}}},[_c('ul',{staticClass:"Slider-list"},[_c('li',[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"in-out"}},[(_vm.imageLs[_vm.currentImageIndex].url)?_c('iframe',{staticClass:"Intrinsic-item Intrinsic-item--model",attrs:{"width":"640","height":"480","src":_vm.imageLs[_vm.currentImageIndex].url,"frameborder":"0","allowvr":"","allowfullscreen":"","mozallowfullscreen":"true","webkitallowfullscreen":"true","onmousewheel":""}}):_c('img',{key:'img-' + _vm.currentImageIndex,staticClass:"Intrinsic-item",class:_vm.imageLs[_vm.currentImageIndex].portait ? 'Intrinsic-item--portrait' : null,attrs:{"oncontextmenu":"return false","alt":_vm.imageLs[_vm.currentImageIndex].title,"src":'./static/images/' + _vm.parentDir + '/' + _vm.imageLs[_vm.currentImageIndex].fileName},on:{"load":_vm.imgHandler,"contextmenu":function($event){_vm.tooltipVisible = true},"mouseout":function($event){_vm.tooltipVisible = false}}})])],1)]),_vm._v(" "),(_vm.tooltipVisible)?_c('span',{staticClass:"Slider-tooltip"},[_vm._v("© Jim & Jamie Dutcher")]):_vm._e()]),_vm._v(" "),(_vm.imageLsLength > 1)?_c('ul',{staticClass:"Slider-mapDots"},_vm._l((_vm.imageLs),function(img,i){return _c('li',{key:'slider-dot-' + i,staticClass:"Slider-mapDots-dot",class:{ 'is-active': i === _vm.currentImageIndex },on:{"click":function($event){_vm.currentImageIndex = i}}})})):_vm._e()]),_vm._v(" "),(_vm.imageLsLength > 1)?_c('div',{staticClass:"col-1 Slider-button"},[_c('div',{staticClass:"ButtonIcon ButtonIcon--oval ButtonIcon--light",attrs:{"title":"Next Image"},on:{"click":function($event){_vm.nextImage()}}},[_c('icon',{attrs:{"name":"arrow-right","scale":".85"}})],1)]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},_vm._l((_vm.imageLs),function(img,i){return (_vm.currentImageIndex === i)?_c('div',{key:'img-caption-' + i,staticClass:"col-md-8 col-xl-6 mx-auto mt-4 Blurb"},[_c('h2',[_vm._v(_vm._s(img.title))]),_vm._v(" "),_c('p',{staticClass:"Blurb-body"},[_vm._v(_vm._s(img.caption))])]):_vm._e()}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m640":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_audio__ = __webpack_require__("aSYd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_background__ = __webpack_require__("QtNj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__explore_wolf_map__ = __webpack_require__("v1UW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__explore_wolf_detail__ = __webpack_require__("huB6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'exploreTheWolf',

  components: {
    appAudio: __WEBPACK_IMPORTED_MODULE_0__partials_audio__["a" /* default */],
    appBackground: __WEBPACK_IMPORTED_MODULE_1__partials_background__["a" /* default */],
    appWolfmap: __WEBPACK_IMPORTED_MODULE_2__explore_wolf_map__["a" /* default */],
    appWolfDetail: __WEBPACK_IMPORTED_MODULE_3__explore_wolf_detail__["a" /* default */]
  },

  data: function data() {
    return {
      overflow: 'visible'
    };
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getLocalData', 'explore');
  },


  computed: {
    helperState: function helperState() {
      return this.$store.getters.helperState;
    },
    wolfContent: function wolfContent() {
      return this.$store.getters.wolfContent;
    },
    wolfState: function wolfState() {
      return this.$store.getters.wolfState;
    }
  },

  methods: {
    setProp: function setProp(parent, key, value) {
      var payload = {
        parent: parent,
        key: key,
        value: value
      };
      this.$store.dispatch('setProp', payload);
    }
  }
});

/***/ }),

/***/ "mRls":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mrPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid Background",style:({ backgroundImage: 'url(' + _vm.backgroundImg + ')' })})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mwqO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_imageSlider__ = __webpack_require__("/4ba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jump_js__ = __webpack_require__("q7+D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_arrow_up__ = __webpack_require__("FE82");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gallerySlide',

  components: {
    appImageSlider: __WEBPACK_IMPORTED_MODULE_0__partials_imageSlider__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */]
  },

  props: {
    sectionIndex: Number,
    slideIndex: Number
  },

  computed: {
    galleryContent: function galleryContent() {
      return this.$store.getters.galleryContent;
    }
  },

  methods: {
    debouncedScroll: _.throttle(function (e, id) {
      // mousewheel delta for IE
      var delta = e.wheelDelta * -1 || e.deltaY;
      var currentSectionId = this.galleryContent.sections[this.sectionIndex].subsections[id].id;
      var currentSection = document.getElementById(currentSectionId).getBoundingClientRect();
      // const yDif = currentSection.y > 0 ? currentSection.top : (currentSection.top * -1)
      // console.log(document.documentElement.clientHeight + yDif - 30, currentSection.height)
      // console.log(document.documentElement.clientHeight, currentSection)
      if (delta < 0 && id === 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_jump_js__["a" /* default */])('#app');
      } else if (delta > 0) {
        // if (document.documentElement.clientHeight + yDif >= currentSection.height) {
        //   const section = this.galleryContent.sections[this.sectionIndex].subsections[id + 1].id
        //   jump('#' + section, {
        //     offset: -80
        //   })
        // }
      } else if (delta < 0) {
        if (currentSection.height > 70) {
          var section = this.galleryContent.sections[this.sectionIndex].subsections[id - 1].id;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_jump_js__["a" /* default */])('#' + section, {
            offset: -80
          });
        }
      }
    }, 1000, {
      'leading': true,
      'trailing': false
    }),

    jumpToId: function jumpToId(selector) {
      var id = '#' + selector;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_jump_js__["a" /* default */])(id);
    }
  }
});

/***/ }),

/***/ "nAmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    generateKey: function generateKey() {
      return Math.random() * Math.random();
    }
  }
});

/***/ }),

/***/ "nH4+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gallery_gallery_section__ = __webpack_require__("+8s/");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'socialBehavior',

  components: {
    appGallerySection: __WEBPACK_IMPORTED_MODULE_0__gallery_gallery_section__["a" /* default */]
  }
});

/***/ }),

/***/ "nVIi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landscape-without-wolves.d1e9f8b.jpg";

/***/ }),

/***/ "nhTD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RouteContainer"},[_c('app-gallery-section',{attrs:{"sectionIndex":2}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oado":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "og5L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pack_anatomy_vue__ = __webpack_require__("Hh58");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b23252_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pack_anatomy_vue__ = __webpack_require__("0rEw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pack_anatomy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b23252_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pack_anatomy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pena":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RouteContainer"},[_c('app-background',{attrs:{"backgroundImg":'./static/images/' + _vm.sharedContent.backgroundImgBlur}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row Gallery"},[_c('div',{staticClass:"col-md-8 mx-auto pb-lg-5 d-block d-md-flex Gallery-container"},[_c('div',{staticClass:"Blurb"},[_c('h2',{staticClass:"Blurb-title text-center"},[_vm._v("\n            "+_vm._s(_vm.galleryContent.title || 'Living with Wolves')+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"Blurb-body"},[_vm._v(_vm._s(_vm.galleryContent.description))]),_vm._v(" "),_c('p',{staticClass:"Blurb-blockquote mt-3 text-center"},[_vm._v("Select a section to begin exploring the hidden life of wolves.")])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},_vm._l((_vm.galleryContent.sections),function(section,i){return _c('div',{key:i,staticClass:"col-lg-3 col-md-5 mx-auto Map",class:'Map--' + i},[_c('router-link',{attrs:{"to":'/wolves-101/' + section.directory + '/'}},_vm._l((section.previewImages),function(previewImg,j){return _c('img',{key:j,staticClass:"Map-wrapper-img",class:['Map-wrapper-img--' + j, { 'zoom-out': _vm.selectedSection === i }],attrs:{"src":'./static/images/gallery/' + section.directory + '/' + previewImg.fileName}})})),_vm._v(" "),_c('router-link',{attrs:{"to":'/wolves-101/' + section.directory + '/'}},[_c('button',{staticClass:"Button Button--dark Map-button"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9 col-lg-12"},[_vm._v("\n                "+_vm._s(section.name)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-3 d-lg-none"},[_c('span',{staticClass:"ButtonIcon ButtonIcon--small ButtonIcon--light Map-button-icon"},[_c('icon',{attrs:{"name":"arrow-right","scale":".85"}})],1)])])])])],1)}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q512":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gallery_gallery_section__ = __webpack_require__("+8s/");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'meetTheWolf',

  components: {
    appGallerySection: __WEBPACK_IMPORTED_MODULE_0__gallery_gallery_section__["a" /* default */]
  }
});

/***/ }),

/***/ "qieW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gallery_gallery_section__ = __webpack_require__("+8s/");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'theBenefitsOfWolves',

  components: {
    appGallerySection: __WEBPACK_IMPORTED_MODULE_0__gallery_gallery_section__["a" /* default */]
  }
});

/***/ }),

/***/ "qxiW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rdKW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],

  data: function data() {
    return {
      detail: {
        title: ''
      },
      instruction: 'Explore the wolf',
      menuIsOpen: false,
      pingHidden: null
    };
  },


  computed: {
    tooltip: function tooltip() {
      return document.getElementsByClassName('Tooltip');
    },
    wolfContent: function wolfContent() {
      return this.$store.getters.wolfContent;
    }
  },

  methods: {
    closeMenu: function closeMenu() {
      this.menuIsOpen = false;
    },
    detailHandler: function detailHandler(selection, mouseState) {
      if (mouseState === 'mouseover' && !this.menuIsOpen) {
        this.detail = this.getDetail(selection);
      } else if (mouseState === 'mouseout') {
        this.resetDetail();
      }
    },
    getDetail: function getDetail(selection) {
      return _.find(this.wolfContent.mapDetail, { name: selection });
    },
    resetDetail: function resetDetail() {
      this.detail = { title: '' };
    },
    updateState: function updateState(selection) {
      var detailObj = this.getDetail(selection);
      var payload = {
        parent: 'wolfmap',
        updates: {
          currentDetail: detailObj,
          currentView: 'appWolfDetail',
          animation: 'slideUp'
        }
      };
      this.$store.dispatch('updateProps', payload);
    }
  },

  created: function created() {
    var _this = this;

    if (this.$route.query.id) {
      setTimeout(function () {
        _this.updateState(_this.$route.query.id);
      }, 1000);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      if (_this2.pingHidden === null) {
        _this2.pingHidden = true;
      }
    }, 1000 * 10);
  }
});

/***/ }),

/***/ "rtvI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_behavior_vue__ = __webpack_require__("nH4+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42000d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_social_behavior_vue__ = __webpack_require__("nhTD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_social_behavior_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42000d12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_social_behavior_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t9Ol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wolves_101_vue__ = __webpack_require__("2ICm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6704c585_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wolves_101_vue__ = __webpack_require__("pena");
function injectStyle (ssrContext) {
  __webpack_require__("bRHh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6704c585"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wolves_101_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6704c585_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wolves_101_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tElb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_background__ = __webpack_require__("QtNj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'take-action',

  components: {
    appBackground: __WEBPACK_IMPORTED_MODULE_0__partials_background__["a" /* default */]
  },

  data: function data() {
    return {
      localContent: [{
        intro: ''
      }, {
        cards: [{ // card one
          image: {
            fileName: '',
            title: ''
          },
          title: '',
          subheadings: ['', '', '', ''],
          socialLinks: [],
          buttons: [{
            text: '',
            link: ''
          }, {
            text: '',
            link: ''
          }, {
            text: '',
            link: ''
          }, {
            text: '',
            link: ''
          }]
        }, { // card two
          image: {
            fileName: '',
            title: ''
          },
          title: '',
          description: '',
          subheadings: [''],
          actions: [],
          button: {
            text: '',
            link: ''
          }
        }, { // card three
          image: {
            fileName: '',
            title: ''
          },
          title: '',
          description: '',
          subheadings: ['', ''],
          button: {
            text: '',
            link: ''
          }
        }]
      }]
    };
  },


  computed: {
    sharedContent: function sharedContent() {
      return this.$store.getters.sharedContent;
    }
  },

  methods: {
    getLocalData: function getLocalData(fileName) {
      var _this = this;

      this.$http.get('./static/data/' + fileName + '.json').then(function (response) {
        return response;
      }).then(function (data) {
        _this.localContent = data.body;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },

  created: function created() {
    this.getLocalData('takeAction');
  }
});

/***/ }),

/***/ "tQIp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Audio"},[_c('audio',{attrs:{"id":_vm.audioId,"src":_vm.src,"loop":"true"}}),_vm._v(" "),_c('p',{staticClass:"Audio-text",on:{"click":_vm.toggleAudio}},[_vm._v(_vm._s(_vm.isPlaying ? 'Mute' : 'Unmute'))]),_vm._v(" "),_c('div',{staticClass:"Audio--controller ButtonIcon ButtonIcon--transparent",on:{"click":function($event){_vm.toggleAudio()}}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isPlaying)?_c('icon',{key:'on',attrs:{"name":"volume-up"}}):_c('icon',{key:'off',attrs:{"name":"volume-off"}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v1UW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wolf_map_vue__ = __webpack_require__("rdKW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a5837c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wolf_map_vue__ = __webpack_require__("7pO/");
function injectStyle (ssrContext) {
  __webpack_require__("z7jf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01a5837c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wolf_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a5837c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wolf_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes__ = __webpack_require__("+iok");





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    helpers: {
      galleryIndex: null,
      overflow: 'visible'
    },

    wolfmap: {
      currentDetail: null,
      currentView: 'appWolfmap',
      animation: 'fade'
    },

    about: new __WEBPACK_IMPORTED_MODULE_2__classes__["a" /* About */](2),

    gallery: new __WEBPACK_IMPORTED_MODULE_2__classes__["b" /* Gallery */](5, 9, 3, 5),

    landscape: {
      audio: '',
      backgroundImg: '',
      intro: '',
      title: '',
      maps: [{
        name: '',
        backgroundImg: '',
        mapImage: ''
      }, {
        name: '',
        backgroundImg: '',
        mapImage: ''
      }]
    },

    shared: {
      backgroundImg: ''
    },

    explore: {
      audio: '',
      backgroundImg: '',
      intro: '',
      mapDetail: []
    }
  },

  getters: {
    aboutContent: function aboutContent(state) {
      return state.about;
    },
    galleryContent: function galleryContent(state) {
      return state.gallery;
    },
    landscapeContent: function landscapeContent(state) {
      return state.landscape;
    },
    sharedContent: function sharedContent(state) {
      return state.shared;
    },
    wolfContent: function wolfContent(state) {
      return state.explore;
    },
    helperState: function helperState(state) {
      return state.helpers;
    },
    wolfState: function wolfState(state) {
      return state.wolfmap;
    }
  },

  mutations: {
    SET_PROP: function SET_PROP(state, payload) {
      var parent = payload.parent;
      var key = payload.key;
      var value = payload.value;

      state[parent][key] = value;
    },
    UPDATE_PROPS: function UPDATE_PROPS(state, payload) {
      var parent = payload.parent;
      var updates = payload.updates;
      state[parent] = updates;
    }
  },

  actions: {
    getLocalData: function getLocalData(_ref, fileName) {
      var commit = _ref.commit;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('./static/data/' + fileName + '.json').then(function (response) {
        return response;
      }).then(function (data) {
        var payload = {
          parent: fileName,
          updates: data.body
        };
        commit('UPDATE_PROPS', payload);
      }).catch(function (err) {
        console.log(err);
      });
    },
    setProp: function setProp(_ref2, payload) {
      var commit = _ref2.commit;

      commit('SET_PROP', payload);
    },
    updateProps: function updateProps(_ref3, payload) {
      var commit = _ref3.commit;

      commit('UPDATE_PROPS', payload);
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_partials_navbar__ = __webpack_require__("LHKt");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appNavbar: __WEBPACK_IMPORTED_MODULE_0__components_partials_navbar__["a" /* default */]
  },

  name: 'app',

  computed: {
    currentRouteIsHome: function currentRouteIsHome() {
      return this.$route.path === '/';
    },
    currentRouteIsGallery: function currentRouteIsGallery() {
      if (this.$route.path === '/wolves-101/meet-the-wolf/' || this.$route.path === '/wolves-101/pack-anatomy/' || this.$route.path === '/wolves-101/social-behavior/' || this.$route.path === '/wolves-101/value-of-having-wolves/' || this.$route.path === '/wolves-101/wolves-and-people/') {
        return true;
      } else {
        return false;
      }
    }
  },

  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getLocalData', 'shared');
  }
});

/***/ }),

/***/ "z0na":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z7jf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.86dd5107293f2c00a7f6.js